import React, { useCallback, useEffect, useRef, useState } from "react";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { getFeed } from "../../Dashboard/Services/DashboardServices";
import moment from "moment";
import { PostDate } from "../../Dashboard/CommonComponents/PostDate";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const EmployeeActivities = ({ employee, employeeId }) => {
  const [feedLst, setFeelLst] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const mediaDefaultImage = "/images/no-data-found/defaultmedia_image.png";
  const [Isloading, setIsloading] = useState(false);

  useEffect(() => {
    if (employeeId) {
      GetFeed();
    }
  }, [employeeId]);

  async function GetFeed() {
    // setIsloading(true);
    const body = {
      OrgId: userDetails?.OrgId,
      // UserId: employeeId,
      EmpId: 0,
      EmpGUID: employee[0]?.GUID,
      FeedId: 0,
      FeedGUID: "",
      IsFeatures: 0,
      pageNumber: 1,
      pageSize: 5,
      LoggedInUserId: userDetails?.EmpId,
    };
    try {
      let Feedlst = await getFeed(body);
      setIsloading(false);
      setFeelLst(Feedlst.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = mediaDefaultImage;
  }, []);

  const renderFeedText = (text) => {
    const mentionRegex = /@\w+/g;
    const hashtagRegex = /#\w+/g;
    let postMention = text?.PostMentions;
    let FeedText = text?.FeedText.slice(0, 100);

    let newText = FeedText?.replace(mentionRegex, (mention) => {
      let matchedMention = postMention?.find(
        (emp) => "@" + emp.MentionedName?.replace(/ /g, "") === mention
      );

      if (!matchedMention) {
        return mention.replace("@", "");
      }

      return `<a href="/Profile/${matchedMention.MentionedGuid}" style="color:rgb(78 168 222);">${matchedMention.MentionedName}</a>`;
    });

    newText = newText?.replace(hashtagRegex, (hashtag) => {
      return `<a style="color: #c4c6c7">${hashtag}</a>`;
    });

    return { __html: newText };
  };

  const videoRef = useRef(null);
  const [posterSrc, setPosterSrc] = useState("");

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.addEventListener("loadeddata", () => {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const poster = canvas.toDataURL("image/jpeg");
        setPosterSrc(poster);
      });
    }
  }, []);

  const FeedCarouselTemplate = useCallback((media) => {
    let PostMedia = media?.PostMedia[0];
    let new_MediaPath = PostMedia?.MediaPath;
    const isVideo = new_MediaPath?.endsWith(".mp4") || new_MediaPath?.toLowerCase()?.endsWith(".mov");
    const mediaSrc = new_MediaPath || "";
    return isVideo ? (
      <video
        className="thankuimg0"
        ref={videoRef}
        src={mediaSrc}
        poster={posterSrc}
        playsInline
        muted
        controls = {false}
      />
    ) : (
      <>
        {mediaSrc && (
          <img
            className="thankuimg0"
            src={mediaSrc || mediaDefaultImage}
            onError={handleImageError}
            alt=""
          />
        )}
      </>
    );
  }, []);

  return (
    <div>
      <div className="profile-about-me">
        <div className="pt-3 border-bottom-1">
          <div className="mb-0 activities">
            <h4 className="text-primary mb-3 sumh4 ">
              Activities
              {feedLst?.length >= 4 && (
                <Link
                  to={`/Feed/User/${employee[0]?.GUID}`}
                  className="view-allactivity"
                >
                  View all
                </Link>
              )}
            </h4>
            <div className="row mb-3">
              {feedLst?.slice(0, 4)?.map((feature, index) => (
                <div className="col-lg-6">
                  <div className="project-1" key={index}>
                    <Link to={`/Feed/Post/${feature?.GUID}`} className="atag">
                      {FeedCarouselTemplate(feature)}
                      <div className="activity-profile">
                        <strong>{feature?.PostedBy}</strong>
                        <p>
                          {moment(feature?.CreatedDate).format(
                            "MMM DD YYYY, h:mm a"
                          )}
                        </p>
                        <p>
                          <p>
                            {feature?.FeedText && (
                              <div key={index} className="post-text">
                                <p
                                  dangerouslySetInnerHTML={renderFeedText(
                                    feature
                                  )}
                                ></p>
                                <p></p>
                              </div>
                            )}
                          </p>
                          <p></p>
                        </p>
                        <div className="social-count mt-2">
                          <div className="likes-count">
                            {feature?.IsLikedByMe != 0 ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="red"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-heart"
                              >
                                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-heart"
                              >
                                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                              </svg>
                            )}
                            {feature?.LikesCount > 0 && (
                              <span>{feature?.LikesCount}</span>
                            )}
                          </div>
                          <div className="comments-count">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-message-circle"
                            >
                              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                            </svg>
                            {feature?.TotalComments > 0 && (
                              <span>{feature?.TotalComments}</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EmployeeActivities;
